import React from "react";
import { connect } from "react-redux";
import Button from "../../componentes/Button.jsx";

/**
 * Mostra informações do usuário na barra superior da aplicação, mostra foto dele
 * e o nome, ao clicar no componente um painel aparece pra realizar o logout.
 */

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
class Navbar extends React.Component {
  state = {
    open: false,
  };

  onClickModal() {
    this.props.dispatch({
      type: "mudar_senha",
    });
  }

  /**
   * Abre o menu sobreposto.
   */
  openMenu() {
    this.setState({ open: true });
  }

  /**
   * Fecha o menu sobreposto.
   */
  closeMenu() {
    this.setState({ open: false });
  }

  renderNavBarPadrao() {
    const { nome_usuario, options, email, id_pk } = this.props.usuario;
    return (
      <ul className="dropdown-menu">
        {/* Painel principal: */}
        {nome_usuario && (
          <li className="user-header">
            <i
              className="fa fa-user-circle-o"
              style={{ fontSize: 60, color: "#333" }}
            />
            <p style={{ width: 250 }}>
              <b>{nome_usuario}</b>
              <br />

              {email && email != "" && email != null && email != "null" && (
                <div>
                  {email}
                  <br />
                </div>
              )}
              {options}
            </p>
          </li>
        )}

        {/* Rodapé do menu que aparece */}
        <li className="user-footer shadow-up-1">
          {id_pk && id_pk && (
            <Button
              className="btn-default btn-block btn-flat"
              label="Alterar Senha"
              icon="fa-unlock-alt"
              onClick={this.onClickModal.bind(this)}
            />
          )}
          {/* Botão de sair: */}
          <Button
            className="btn-default btn-block btn-flat"
            label="Preferências"
            icon="fa-wrench"
            onClick={this.props.onPreferencias}
          />
          <Button
            className="btn-default btn-block btn-flat"
            label="Sair"
            icon="fa-sign-out"
            onClick={this.props.onLogout}
          />
        </li>
      </ul>
    );
  }

  render() {
    const { nome_usuario } = this.props.usuario;
    return (
      <div className="navbar-custom-menu">
        <ul className="nav navbar-nav">
          <li
            onMouseEnter={this.openMenu.bind(this)}
            onMouseLeave={this.closeMenu.bind(this)}
            className={`dropdown user user-menu ${
              this.state.open ? "open" : ""
            }`}
          >
            <a
              aria-expanded={this.state.open ? "true" : "false"}
              className="dropdown-toggle"
              // style={{ marginTop: isMobile && "-10px" }}
            >
              <i
                className="fa fa-user-circle-o "
                style={{ fontSize: 20, color: "#fff" }}
              />
              <span className="hidden-xs">{nome_usuario}</span>
            </a>

            {global.app.options &&
              global.app.options.renderNavBar &&
              global.app.options.renderNavBar()}
            {(!global.app.options || !global.app.options.renderNavBar) &&
              this.renderNavBarPadrao()}
          </li>
        </ul>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    usuario: state.usuario,
  }),
  (dispatch) => ({ dispatch })
)(Navbar);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/header/Navbar.jsx